module.exports = __webpack_public_path__ + "html/light-landing_d35d018c928e5d73c96d954a06181931.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/light/light-landing.html
// module id = FnqE
// module chunks = 51